import MetaSiteDetails from './MetaSiteDetails';

export default MetaSiteDetails;
